/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCalculatorChart = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M21 2H3v20h9.255a6.972 6.972 0 0 1-.965-2H5V4h14v7.07a6.952 6.952 0 0 1 2 .604zm-8 10h-2v2h2zm-6 2h2v-2H7zm0 4h2v-2H7zM17 6H7v4h10zm-2 12c0-1.306.835-2.417 2-2.83V19h3.83A3.001 3.001 0 0 1 15 18zm3-5a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCalculatorChart as CalculatorChart };
